import StorageIcon from '@material-ui/icons/Storage';
import { StorageTransactionsList } from './List/List';
import { StorageTransactionsShow } from './Show/Show';

export {
    StorageTransactionsList,
    StorageTransactionsShow,
};

export const storageTransactionsResource = {
    list: StorageTransactionsList,
    show: StorageTransactionsShow,
    icon: StorageIcon,
};
